// mpgsBridge.js

class MPGSBridge {
  constructor() {
    this.callbacks = {};
  }

  setCallbacks(cb) {
    this.callbacks = cb || {};
  }

  init() {
    window.__mpgsBridge__ = {
      error: (err) => this.callbacks.onError && this.callbacks.onError(err),
      cancel: () => this.callbacks.onCancel && this.callbacks.onCancel(),
      complete: (ri, sv) =>
        this.callbacks.onComplete &&
        this.callbacks.onComplete({
          resultIndicator: ri,
          sessionVersion: sv,
        }),
    };
  }
}

export const mpgsBridge = new MPGSBridge();
